import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { UserApiService } from '../user-api.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  _islog : boolean = false;

  constructor(private userApiService : UserApiService) { }

  @Output() menuEmit = new EventEmitter<boolean>();
  toggleSideNav() {
    this.menuEmit.emit(true);
  }

  ngOnInit() {
    this.userApiService.getCurrentUserData().subscribe(
      response => {
        if (response != undefined) {
          this._islog = true;
        }
      },
      error => {
        this._islog = false;        
      }
    );
  }
}
